<template>
    <component :is="way" :response="response"/>
</template>
<script>

  import PROCESS_NAMES from '@/process/names';
  import ActionsDefault from './default.vue';
  const ActionsSkolkovo = () => import(/* webpackChunkName: "skolkovo-default" */'@/process/skolkovo/components/response/actions/index.vue');

  export default {
    name: 'additional-actions',
    props: {
      response: Object
    },
    components: {
      ActionsDefault,
      ActionsSkolkovo
    },
    computed: {
      way () {
        const way = 'actions';
        const process = this.$store.getters['response/process'];

        if (process === PROCESS_NAMES.SKOLKOVO) {
          return `${way}-${process}`;
        }

        return `${way}-default`;
      }
    }
  }
</script>
